import React from "react"
import Index from "./Index"
import { contentLayout, modules } from "../config/const"
import { useUser } from "../contexts/UserContext"
import Forbidden from "./Forbidden"

function RegisterSale (){
  const {user} = useUser()
  let view = contentLayout[modules.RegisterSale]
  if(user.permissions.views.length && !user.permissions.views.join().includes(modules.RegisterSale.toLowerCase())){
    view = Forbidden
  }
  return(
  <Index content={view} module={modules.RegisterSale}></Index>
 )
}

export default RegisterSale